import {Component, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-jaarrekening',
  templateUrl: './overzicht-jaarrekening.component.html',
  styleUrls: ['./overzicht-jaarrekening.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class OverzichtJaarrekeningComponent implements OnInit {
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    specJaarrekeningFormGroup = this.fb.group({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specJaarrekeningFormGroup = this.fb.group<AangifteRapport>({
            // specificatieJaarrekening: this.fb.array<SpecificatieJaarrekening>([
            //     this.fb.group({
            //         opbouw: this.fb.group<OpbouwJaarrekening>(<OpbouwJaarrekening>({
            //             naamOnderneming: '' as unknown as string,
            //             winstVolgensResultatenRekening: null as unknown as number,
            //             aandeelInWinstVolgensResultatenRekening: null as unknown as number,
            //             nietAftrekbareKostenEnLasten: null as unknown as number,
            //             investeringsAftrek: null as unknown as number,
            //             investeringsBijtelling: null as unknown as number,
            //             mutatieHIR: null as unknown as number,
            //             mutatieKER: null as unknown as number,
            //             mutatieFOR: null as unknown as number,
            //             winstPerOnderneming: null as unknown as number,
            //             totaleOmzet: null as unknown as number,
            //             totaleStakingsWinst: null as unknown as number,
            //             totaleVrijgesteldeWinst: null as unknown as number,
            //             totaleFinancieleBaten: null as unknown as number,
            //             totaleBuitengewoneBaten: null as unknown as number,
            //             totaleInkoopkosten: null as unknown as number,
            //             totalePersoneelskosten: null as unknown as number,
            //             totaleHuisvestingskosten: null as unknown as number,
            //             totaleAutokosten: null as unknown as number,
            //             totaleVerkoopkosten: null as unknown as number,
            //             totaleOverigeKosten: null as unknown as number,
            //             totaleAfschrijvingen: null as unknown as number,
            //             totaleFinancieleLasten: null as unknown as number,
            //             totaleBuitengewoneLasten: null as unknown as number,
            //             immaterieelVastActiefOpeningsbalans: null as unknown as number,
            //             materieelVastActiefOpeningsbalans: null as unknown as number,
            //             fiancieelVastActiefOpeningsbalans: null as unknown as number,
            //             voorraadActivaOpeningsbalans: null as unknown as number,
            //             vorderingenActivaOpeningsbalans: null as unknown as number,
            //             effectenOpeningsbalans: null as unknown as number,
            //             liquideMiddelenOpeningsbalans: null as unknown as number,
            //             eigenVermogenOpeningsbalans: null as unknown as number,
            //             voorzieningenOpeningsbalans: null as unknown as number,
            //             kortlopendeSchuldenOpeningsbalans: null as unknown as number,
            //             langlopendeSchuldenOpeningsbalans: null as unknown as number,
            //             immaterieelVastActiefSlotbalans: null as unknown as number,
            //             materieelVastActiefSlotbalans: null as unknown as number,
            //             financieelVastActiefSlotbalans: null as unknown as number,
            //             voorraadActivaSlotbalans: null as unknown as number,
            //             vorderingenActivaSlotbalans: null as unknown as number,
            //             effectenSlotbalans: null as unknown as number,
            //             liquideMiddelenSlotbalans: null as unknown as number,
            //             eigenVermogenSlotbalans: null as unknown as number,
            //             voorzieningenSlotbalans: null as unknown as number,
            //             kortlopendeSchuldenSlotbalans: null as unknown as number,
            //             langlopendeSchuldenSlotbalans: null as unknown as number,
            //             totaalActiefOpeningsbalans: null as unknown as number,
            //             totaalPassiefOpeningsbalans: null as unknown as number,
            //             totaalActiefSlotbalans: null as unknown as number,
            //             totaalPassiefSlotbalans: null as unknown as number,
            //             // specificatieZeescheepvaart?: SpecificatieZeescheepvaart[];
            //             beginVermogen: null as unknown as number,
            //             eindVermogen: null as unknown as number,
            //             totaleOnttrekkingen: null as unknown as number,
            //             totaleStortingen: null as unknown as number,
            //             totaleKIA: null as unknown as number,
            //             onbenutteKIA: null as unknown as number,
            //             benutteKIA: null as unknown as number,
            //             totaleMIA: null as unknown as number,
            //             onbenutteMIA: null as unknown as number,
            //             benutteMIA: null as unknown as number,
            //             totaleEIA: null as unknown as number,
            //             onbenutteEIA: null as unknown as number,
            //             benutteEIA: null as unknown as number,
            //             totaleDIB: null as unknown as number,
            //             // aftrekPerBedrijfmiddel?: InvesteringsAftrekSpecificatie[];
            //             maximaleDotatieFor: null as unknown as number,
            //         })
            //     })
            // ])
        })
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    // this.specWUO = value;
                    // this.specWUOFormGroup.patchValue(this.specWUO)
                });
            }
        });
    }

}
